import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { Sparkles } from 'lucide-react';

export default function LanguageSelect() {
  const { setLang } = useLanguage();
  const navigate = useNavigate();

  const choose = (l) => {
    setLang(l);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-ivory flex flex-col items-center justify-center px-6 py-16">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex w-14 h-14 rounded-2xl bg-terracotta-light items-center justify-center mb-6">
          <Sparkles size={24} className="text-terracotta" />
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-ink mb-3">
          Choose your language
        </h1>
        <p className="text-ink-secondary mb-2">请选择语言</p>
        <p className="text-sm text-ink-tertiary mb-10">
          You can switch any time from the header
        </p>

        <div className="space-y-3">
          <button
            onClick={() => choose('zh')}
            data-testid="lang-zh-btn"
            className="w-full min-h-[64px] bg-paper hover:bg-terracotta-light/40 border-2 border-border hover:border-terracotta rounded-2xl text-lg font-medium text-ink transition-all hover:-translate-y-0.5 hover:shadow-md"
          >
            中文
          </button>
          <button
            onClick={() => choose('en')}
            data-testid="lang-en-btn"
            className="w-full min-h-[64px] bg-paper hover:bg-terracotta-light/40 border-2 border-border hover:border-terracotta rounded-2xl text-lg font-medium text-ink transition-all hover:-translate-y-0.5 hover:shadow-md"
          >
            English
          </button>
          <div
            data-testid="lang-ms-coming"
            className="w-full min-h-[64px] bg-subtle border-2 border-border rounded-2xl text-base font-medium text-ink-tertiary flex items-center justify-center"
          >
            Bahasa Malaysia · Coming soon
          </div>
        </div>
      </div>
    </div>
  );
}
